export function getSystem(){
    let system = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    const windows = system.indexOf("windows");
    let os = '';
    if (windows !== -1) {
        os = 'windows'
    }else if (isMac) {
        os = 'mac'
    }else {
        os = 'devtools'
    }
    return os;
}
